module.exports = __webpack_public_path__ + "static/media/export-citations.c96f8c74.svg";